import type {ExpressionV4, Metadata} from '../types';

export const addNewExpression = (
  newExpression: ExpressionV4,
  currentMetadata: Metadata,
): Metadata => {
  return {
    ...currentMetadata,
    expressions: [...currentMetadata.expressions, newExpression],
  };
};
